export const ImgWithFallback = ({ src, webpSrc = null, ...rest }) => {
  return <picture>{webpSrc ? <source srcSet={webpSrc} type={'image/webp'} /> : <img src={src} {...rest} />}</picture>
}
